import React from "react";
import useGetRequest from "../../hooks/useGetRequest";
import MaterialStats from "../../components/MaterialStats/materialStats.component";
import ProduceStats from "../../components/ProduceStats/produceStats.component";
import ClientStats from "../../components/ClientStats/clientStats.component";
import CashboxesStats from "../../components/CashboxesStats/cashboxesStats.component";
import Turnover from "../../components/Turnover/turnover.component";
import TaskOrders from "../../components/TaskOrders/taskOrders.component";
import CashTransferStats from "../../components/CashTransferStats/cashTransferStats.component";
import RecentReports from "../../components/RecentReports/recentReports.component";
import MissingPositionsStats from "../../components/MissingPositionsStats/missingPositionsStats.component";
import { useAuth } from "../../contexts/auth.context";
import { UserRole } from "../../types/user.type";
import FillersInOrder from "../../components/FillersInOrder/fillersInOrder.component";

export default function Home() {
  const { authState } = useAuth();
  const { data: materials, loading: materialsLoading } =
    useGetRequest("/stats/materials");
  const { data: produces, loading: producesLoading } =
    useGetRequest("/stats/produces");
  const { data: clients, loading: clientsLoading } =
    useGetRequest("/stats/clients");
  const { data: cashboxStats, loading: cashboxLoading } =
    useGetRequest("/stats/cashbox");
  const { data: turnoverStats, loading: turnoverLoading } =
    useGetRequest("/stats/turnover");
  const { data: taskOrders, loading: taskOrdersLoading } =
    useGetRequest("/stats/task-orders");
  const { data: cashTransferStats, loading: cashTransferLoading } =
    useGetRequest("/stats/cash-transfer-clients");
  const { data: recentReports, loading: recentReportsLoading } = useGetRequest(
    "/stats/recent-reports"
  );
  const { data: fillersStats, loading: fillersStatLoading } =
    useGetRequest("/stats/fillers");
  const { data: missingPositionsStats, loading: missingPositionsLoading } =
    useGetRequest("/position/missing");
  return (
    <div>
      {authState.user?.role === UserRole.Admin && (
        <Turnover data={turnoverStats} loading={turnoverLoading} />
      )}

      <CashboxesStats data={cashboxStats} loading={cashboxLoading} />
      <MissingPositionsStats data={missingPositionsStats} loading={missingPositionsLoading} />
      <MaterialStats data={materials} loading={materialsLoading} />
      <ProduceStats data={produces} loading={producesLoading} />
      <TaskOrders data={taskOrders} loading={taskOrdersLoading} />
      <ClientStats data={clients} loading={clientsLoading} />
      <CashTransferStats
        data={cashTransferStats}
        loading={cashTransferLoading}
      />
      <RecentReports data={recentReports} loading={recentReportsLoading} />
      <FillersInOrder data={fillersStats} loading={fillersStatLoading} />
    </div>
  );
}
